// #region imports

// --- Angular
import { Component, Input } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-results-locked',
  templateUrl: './results-locked.component.html',
  styleUrls: ['./results-locked.component.scss']
})
export class ResultsLockedComponent {

  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() hideLockContent: boolean = true;
}
